import { render } from "./MainPaging.vue?vue&type=template&id=97262d7c&scoped=true"
import script from "./MainPaging.vue?vue&type=script&lang=js"
export * from "./MainPaging.vue?vue&type=script&lang=js"

import "@/assets/css/style.css?vue&type=style&index=0&id=97262d7c&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97262d7c"]])

export default __exports__